export const DEFAULT_CATEGORIES = [
  { id: 'timber', name: 'Timber', color: '#8B5E3C', sort_order: 1 },
  { id: 'fixings', name: 'Fixings & Hardware', color: '#1a7a8a', sort_order: 2 },
  { id: 'adhesives', name: 'Adhesives, Sealants & Finishes', color: '#9b59b6', sort_order: 3 },
  { id: 'site', name: 'Site Materials', color: '#5d6d7e', sort_order: 4 },
  { id: 'labour', name: 'Labour', color: '#9a6b1e', sort_order: 5 },
  { id: 'additional', name: 'Additional', color: '#e74c3c', sort_order: 6 },
]

// Labour lines — stamp into every new project at default days
export const DEFAULT_LABOUR_LINES = [
  { name: 'Project Admin', default_days: 1, sort_order: 1 },
  { name: 'Design and production drawings', default_days: 1, sort_order: 2 },
  { name: 'Goods and materials collection', default_days: 0, sort_order: 3 },
  { name: 'Build & Install', default_days: 0, sort_order: 4, from_estimator: true },
  { name: 'Dispose of waste', default_days: 0.25, sort_order: 5 },
]

// Build & Install task catalogue — used in the B&I calculator
// unit_duration is stored in hours; is_multiplied: true = hrs × qty, false = fixed hrs
export const DEFAULT_TASK_CATALOGUE = [
  // Workshop preparation
  { name: 'Domino panels', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 8, sort_order: 1 },
  { name: 'Mark up hardware', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 2.5, sort_order: 2 },
  { name: 'Sand and Osmo oak panels', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 12, sort_order: 3 },
  { name: 'Build cabinets', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 8, sort_order: 4 },
  { name: 'Fit hardware', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 2, sort_order: 5 },
  { name: 'Domino supports', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 1, sort_order: 6 },
  { name: 'Fit supports', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 1, sort_order: 7 },
  { name: 'Make drawer runner spacers', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 1, sort_order: 8 },
  { name: 'Fit Axilo feet bases', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 1, sort_order: 9 },
  { name: 'Fit locking devices to drawers', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 1, sort_order: 10 },
  { name: 'Domino scribe, plinth and top scribe parts', phase: 'Workshop preparation', is_multiplied: true, unit_duration: 2.5, sort_order: 11 },
  { name: 'Cut power socket apertures', phase: 'Workshop preparation', is_multiplied: false, unit_duration: 1, sort_order: 12 },
  { name: 'Prepare wall battens', phase: 'Workshop preparation', is_multiplied: false, unit_duration: 1, sort_order: 13 },
  // Onsite
  { name: 'Load in', phase: 'Onsite', is_multiplied: false, unit_duration: 2, sort_order: 14 },
  { name: 'Prepare installation site', phase: 'Onsite', is_multiplied: false, unit_duration: 1, sort_order: 15 },
  { name: 'Install battens', phase: 'Onsite', is_multiplied: false, unit_duration: 1, sort_order: 16 },
  { name: 'Build cabs onsite', phase: 'Onsite', is_multiplied: true, unit_duration: 4, sort_order: 17 },
  { name: 'Fit cabs', phase: 'Onsite', is_multiplied: true, unit_duration: 8, sort_order: 18 },
  { name: 'Cut and fit scribes, plinth and top scribes', phase: 'Onsite', is_multiplied: true, unit_duration: 8, sort_order: 19 },
  // Finish
  { name: 'Fit rail & brackets', phase: 'Finish', is_multiplied: false, unit_duration: 1, sort_order: 20 },
  { name: 'Fit drawers', phase: 'Finish', is_multiplied: true, unit_duration: 1, sort_order: 21 },
  { name: 'Fit doors', phase: 'Finish', is_multiplied: true, unit_duration: 1, sort_order: 22 },
  { name: 'Cover caps', phase: 'Finish', is_multiplied: false, unit_duration: 1, sort_order: 23 },
  { name: 'Caulk', phase: 'Finish', is_multiplied: false, unit_duration: 1, sort_order: 24 },
  { name: 'Clean interior and exterior', phase: 'Finish', is_multiplied: false, unit_duration: 1, sort_order: 25 },
  { name: 'Touch-up paint', phase: 'Finish', is_multiplied: false, unit_duration: 1, sort_order: 26 },
  { name: 'Clean installation site', phase: 'Finish', is_multiplied: false, unit_duration: 2, sort_order: 27 },
  { name: 'Contingency', phase: 'Finish', is_multiplied: false, unit_duration: 4, sort_order: 28 },
]

export const DEFAULT_SETTINGS = {
  day_rate: 350,
  hours_per_day: 8,
  margin_on_labour_pct: 10,
  vat_rate: 20,
}

// Master catalogue — seed data from your spreadsheet
// These stamp into every new project at their default quantities
// Edit these in the app via the Catalogue screen
export const CATALOGUE_SEED = [
  // ── Timber ──────────────────────────────────────────────────
  { category: 'timber', description: 'MFC sheets — Cworkshop incl. delivery', unit_cost: 0, default_qty: 0, sort_order: 1 },
  { category: 'timber', description: 'Poplar Furniture Board', unit_cost: 0, default_qty: 0, sort_order: 2 },
  { category: 'timber', description: 'Battens', unit_cost: 0, default_qty: 0, sort_order: 3 },
  { category: 'timber', description: 'PO Joyce', unit_cost: 0, default_qty: 0, sort_order: 4 },
  { category: 'timber', description: 'Timber Cut4You', unit_cost: 0, default_qty: 0, sort_order: 5 },

  // ── Fixings & Hardware ───────────────────────────────────────
  { category: 'fixings', description: 'Screw packs', unit_cost: 7.00, default_qty: 2, sort_order: 1 },
  { category: 'fixings', description: 'Wall plugs', unit_cost: 8.00, default_qty: 1, sort_order: 2 },
  { category: 'fixings', description: 'L brackets', unit_cost: 0.90, default_qty: 0, sort_order: 3 },
  { category: 'fixings', description: 'Dominos', unit_cost: 5.00, default_qty: 1, sort_order: 4 },
  { category: 'fixings', description: 'Shelf studs', unit_cost: 5.00, default_qty: 0, sort_order: 5 },
  { category: 'fixings', description: 'Häfele axilo adjustable feet', unit_cost: 1.75, default_qty: 0, sort_order: 6 },
  { category: 'fixings', description: 'Electrical componentry', unit_cost: 15.00, default_qty: 0, sort_order: 7 },
  { category: 'fixings', description: 'Cable outlet grommets', unit_cost: 15.00, default_qty: 0, sort_order: 8 },
  { category: 'fixings', description: 'Contingency', unit_cost: 50.00, default_qty: 1, sort_order: 9 },

  // ── Adhesives, Sealants & Finishes ───────────────────────────
  { category: 'adhesives', description: 'Caulk', unit_cost: 6.00, default_qty: 1, sort_order: 1 },
  { category: 'adhesives', description: 'Silicone sealant', unit_cost: 5.00, default_qty: 0, sort_order: 2 },
  { category: 'adhesives', description: 'Construction adhesive', unit_cost: 8.00, default_qty: 1, sort_order: 3 },
  { category: 'adhesives', description: 'Osmo Oil', unit_cost: 38.00, default_qty: 0, sort_order: 4 },
  { category: 'adhesives', description: 'Sanding disks', unit_cost: 0.50, default_qty: 10, sort_order: 5 },
  { category: 'adhesives', description: 'Rags, rollers, tack cloths', unit_cost: 15.00, default_qty: 0, sort_order: 6 },
  { category: 'adhesives', description: 'Cover caps', unit_cost: 18.00, default_qty: 1, sort_order: 7 },
  { category: 'adhesives', description: 'Contingency', unit_cost: 50.00, default_qty: 1, sort_order: 8 },

  // ── Site Materials ───────────────────────────────────────────
  { category: 'site', description: 'Masking tape', unit_cost: 5.00, default_qty: 1, sort_order: 1 },
  { category: 'site', description: 'Silver tape', unit_cost: 7.00, default_qty: 1, sort_order: 2 },
  { category: 'site', description: 'Festool vacuum bags', unit_cost: 2.50, default_qty: 2, sort_order: 3 },
  { category: 'site', description: 'Dust sheets', unit_cost: 4.00, default_qty: 2, sort_order: 4 },
  { category: 'site', description: 'Floor protection', unit_cost: 4.00, default_qty: 2, sort_order: 5 },
  { category: 'site', description: 'Rubble sacks', unit_cost: 0.50, default_qty: 5, sort_order: 6 },

  // ── Labour lines ─────────────────────────────────────────────
  // These are days-based — unit_cost stores default_days here
  { category: 'labour', description: 'Project Admin', unit_cost: 1, default_qty: 1, sort_order: 1 },
  { category: 'labour', description: 'Design and production drawings', unit_cost: 1, default_qty: 1, sort_order: 2 },
  { category: 'labour', description: 'Goods and materials collection', unit_cost: 0, default_qty: 1, sort_order: 3 },
  { category: 'labour', description: 'Dispose of waste', unit_cost: 0.25, default_qty: 1, sort_order: 4 },
]

export const PROCUREMENT_OPTIONS = [
  { value: 'order', label: 'Order', color: '#1a7a8a', bg: '#e8f6f8' },
  { value: 'stock', label: 'Stock', color: '#9a6b1e', bg: '#fdf6e7' },
]

export const HART_BASE_URL = 'https://www.blum.org.uk'

// Collection slugs verified from blum.org.uk
// To add more: browse to the collection on the site, copy the slug after /collections/
// Empty collections are marked and hidden in the UI automatically
export const HART_CATEGORIES = [
  {
    name: 'Blum',
    subcategories: [
      {
        name: 'Hinges — Clip Top',
        collection: 'blum-hinges-clip-top',
        description: 'Clip Top Blumotion hinges, all angles and overlays'
      },
      {
        name: 'Hinge Accessories',
        collection: 'blum-hinges-hinge-accessories',
        description: 'Mounting plates, adaptors and accessories for Clip Top hinges'
      },
      {
        name: 'Runners — Movento',
        collection: 'blum-drawer-runners-movento',
        description: 'Undermount runners with Blumotion soft-close'
      },
      {
        name: 'Runners — Tandem',
        collection: 'blum-drawer-runners-tandem',
        description: 'Side-mount Tandem runners'
      },
      {
        name: 'Runners — Base Fix',
        collection: 'blum-drawer-runners-base-fix',
        description: 'Base-mounted drawer runners'
      },
      {
        name: 'Runner Accessories',
        collection: 'blum-drawer-runners-accessories',
        description: 'Sync clips, pull-outs, locking devices'
      },
      {
        name: 'Tools & Jigs',
        collection: 'blum-assembly-tools-jigs-tools-jigs',
        description: 'Drilling jigs, installation tools'
      },
      // Placeholder entries for future use — add collection slug when verified
      // { name: 'Box Systems — Tandembox', collection: '', description: '' },
      // { name: 'Aventos Lift Systems', collection: '', description: '' },
    ]
  },
  // Future suppliers — uncomment and add verified collection slugs when needed
  // {
  //   name: 'Häfele',
  //   subcategories: [
  //     { name: 'Legs, Castors & Glides', collection: '' },
  //   ]
  // },
  // {
  //   name: 'Osmo',
  //   subcategories: [
  //     { name: 'All Osmo', collection: '' },
  //   ]
  // },
]
